import { SelectGroup, SelectItem, SelectLabel } from '@/components/ui/select'
import { type EmailTemplate } from '@/models/emailTemplate'

interface EmailTemplateSelectItemsProps {
  templates: EmailTemplate[]
}

/** A template dropdown's options: the global templates, then the rep's own. */
export function EmailTemplateSelectItems({ templates }: EmailTemplateSelectItemsProps) {
  const groups = [
    { label: 'Global', items: templates.filter((t) => t.isGlobal) },
    { label: 'Personal', items: templates.filter((t) => !t.isGlobal) },
  ]

  return (
    <>
      {groups
        .filter((group) => group.items.length > 0)
        .map((group) => (
          <SelectGroup key={group.label}>
            <SelectLabel>{group.label}</SelectLabel>
            {group.items.map((t) => (
              <SelectItem key={t.id} value={t.id}>
                {t.displayName || 'Untitled'}
              </SelectItem>
            ))}
          </SelectGroup>
        ))}
    </>
  )
}
